import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import CsvPriceUpload from './csvPriceUpload';

@observer
class ProductLibraryImport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedList: null,
            preview: null,
            isLoading: false,
            error: null,
        };
    }

    componentDidMount() {
        const { productListStore } = this.props.stores;
        productListStore.loadPublished();
    }

    selectList = async (list) => {
        const { productListStore } = this.props.stores;
        this.setState({ isLoading: true, error: null, selectedList: list, preview: null });
        const response = await productListStore.previewList(list.id);
        if (response && response.status === 200) {
            this.setState({ preview: response.data, isLoading: false });
        } else {
            this.setState({
                error: (response && response.message) || 'Kunne ikke laste varelisten',
                isLoading: false,
            });
        }
    }

    backToList = () => this.setState({ selectedList: null, preview: null, error: null });

    render() {
        const { productListStore } = this.props.stores;
        const { productLists } = productListStore;
        const {
            selectedList, preview, isLoading, error,
        } = this.state;
        const { onComplete, onClose } = this.props;

        if (selectedList && preview) {
            return (
                <div class='mb-3'>
                    <button type='button' class='btn btn-sm btn-outline-secondary rounded-pill mb-2' onClick={this.backToList}>
                        <i class='fa-solid fa-arrow-left me-1' /> <Text id='productlist.back-to-lists'>Back to lists</Text>
                    </button>
                    <h6>{selectedList.name}</h6>
                    <CsvPriceUpload
                        stores={this.props.stores}
                        presetPreview={preview}
                        onClose={onClose}
                        onComplete={onComplete}
                    />
                </div>
            );
        }

        return (
            <div class='mb-3'>
                {error && <div class='alert alert-danger'>{error}</div>}
                {isLoading && (
                    <div class='text-body-secondary p-2'>
                        <i class='fa-solid fa-spinner fa-spin me-1' /> <Text id='productlist.loading'>Loading…</Text>
                    </div>
                )}
                {productLists.length === 0 && !isLoading && (
                    <div class='text-body-secondary p-2'>
                        <Text id='productlist.none'>No product lists available yet.</Text>
                    </div>
                )}
                <div class='list-group'>
                    {productLists.map(list => (
                        <button type='button' class='list-group-item list-group-item-action' onClick={() => this.selectList(list)}>
                            <div class='d-flex justify-content-between'>
                                <strong>{list.name}</strong>
                                {list.itemCount > 0 && (
                                    <small class='text-body-secondary'>
                                        {list.itemCount} <Text id='productlist.items'>items</Text>
                                    </small>
                                )}
                            </div>
                            {list.supplier && <small class='text-body-secondary'>{list.supplier}</small>}
                            {list.description && <div><small class='text-body-secondary'>{list.description}</small></div>}
                        </button>
                    ))}
                </div>
            </div>
        );
    }
}

export default ProductLibraryImport;
